import { render } from "./change-acct-leverage.vue?vue&type=template&id=21983671"
import script from "./change-acct-leverage.vue?vue&type=script&lang=js"
export * from "./change-acct-leverage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__